<div class="next-turn">NEXT TURN</div>
<nb-card-body>
  <div class="turn-order-item" *ngFor="let e of orderedData; index as i">
    <div class="turn-order-item--upper">
      <app-avatar [size]="'giant'" [name]="e?.employee?.firstName" [avatarUrl]="e?.employee?.avatarUrl"></app-avatar>
      <nb-badge text="#{{ i + 1 }}" status="warning" position="top left"></nb-badge>
      <nb-badge text="{{ e.turnCnt }}" status="info" position="bottom left"></nb-badge>
    </div>
    <!--    <div class="turn-order-item&#45;&#45;lower"></div>-->
  </div>
</nb-card-body>
